import { useMemo, CSSProperties, useCallback } from 'react';
import { Property } from '~/shared/services';
import { GetMessageComponent } from '~/shared/components/parts/Message/Message';
import {
  AmountBoxValidateOption,
  AmountBox as AmountboxComponent,
  Amount,
  AmountBoxDisplayOption,
} from '~/shared/components/parts/Amountbox/AmountBox';
import { Amounts } from '~/shared/utils';
import { getProperty } from '../common';

export interface AmountboxProps {
  name: string;
  className?: string;
  labelId?: string;
  value?: Amounts;
  placeholder?: string;
  disabled?: boolean;
  validator?: (v: number) => string[];
  displayOption?: AmountBoxDisplayOption;
  validateOption?: AmountBoxValidateOption;
  properties?: Property[];
  columns?: string[];
  onChangeState?: (arg: Amount | null) => void;
}

export function Amountbox(props: AmountboxProps) {
  const { onChangeState } = props;
  const [componentStyle, viewStyle, _disabled] = useMemo<
    [CSSProperties, CSSProperties, boolean]
  >(() => {
    return getProperty(props.name, props.columns, props.properties);
  }, [props.properties, props.columns, props.name]);
  const disabled = _disabled ? _disabled : props.disabled ?? false;

  const onChange = useCallback(
    (v: Amount | null) => {
      onChangeState && onChangeState(v);
    },
    [onChangeState]
  );
  return (
    <div style={viewStyle}>
      <span className={props.labelId !== '' ? 'caption' : 'caption no-name'}>
        {props.labelId && (
          <div className={props.validateOption?.required ? 'required ' : ''}>
            <div
              className={`topping-label ${
                disabled ? 'disabled-topping-label' : ''
              }`}
            >
              {props.labelId !== '' ? (
                <GetMessageComponent id={props.labelId} />
              ) : (
                ''
              )}
            </div>
          </div>
        )}
      </span>
      <AmountboxComponent
        name={props.name}
        className={props.className}
        value={props.value}
        placeholder={props.placeholder}
        validator={props.validator}
        validateOption={props.validateOption}
        displayOption={props.displayOption}
        disabled={disabled ? true : false}
        style={componentStyle}
        onChangeState={onChange}
      ></AmountboxComponent>
    </div>
  );
}
